import * as React from "react";
import { AddressRequirement, LocationSearchMode } from "./types";
import { ZipCodeSelector } from "./ZipCodeComponent";
import { LocationSearchComponent } from "./LocationSearchComponent";
import { safeReloadPage } from "src/lib/common";

type LocationSearchProps = {
  addressRequirement?: AddressRequirement;
  onLocationSelected: (loc: SimpleLocation) => void;
  onZipSelected: (zip: string) => void;
};

export const LocationSearchModal: React.FC<LocationSearchProps> = (props) => {
  const initState =
    props.addressRequirement === AddressRequirement.Location
      ? LocationSearchMode.HOSPITAL
      : LocationSearchMode.NONE;

  const [selectionType, setSelectionType] =
    React.useState<LocationSearchMode>(initState);
  /**
   * change the selection mode of the location selection component
   * @param e
   */
  const handleSelectionMode = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    const value = parseInt(e.target.value, 10);

    setSelectionType(value);
  };

  const defaultState = {
    selectionType: LocationSearchMode.NONE,
  };

  // automatically select the hospital if that is the only option.
  if (props.addressRequirement === AddressRequirement.Location) {
    defaultState.selectionType = LocationSearchMode.HOSPITAL;
  }

  return (
    <div className="inner">
      <h2 id="locationselectiontitle">
        Select a location to confirm delivery availability
      </h2>

      {props.addressRequirement === AddressRequirement.ZipCode && (
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label htmlFor="selectionType">I am delivering to a</label>
              <select
                id="selectionType"
                className="form-control"
                value={selectionType}
                name="selectionType"
                onChange={handleSelectionMode}
              >
                <option value={LocationSearchMode.NONE}>Select Type</option>
                <option value={LocationSearchMode.ZIP}>Residence</option>
                <option value={LocationSearchMode.HOSPITAL}>Hospital</option>
              </select>
            </div>
          </div>
        </div>
      )}

      {selectionType === LocationSearchMode.HOSPITAL && (
        <LocationSearchComponent
          handleSelect={(item) => {
            props.onLocationSelected(item);
          }}
        />
      )}

      {selectionType === LocationSearchMode.ZIP && (
        <ZipCodeSelector onLocationSelected={props.onZipSelected} />
      )}
    </div>
  );
};
